import styled from "styled-components";

export const Button = styled.button`
  color: ${(props) => (props.dark ? "#fff" : "#201e20")};
  border: ${(props) => (props.outlined ? "1px solid #aca9b3" : "none")};
  border-radius: ${(props) => (props.rounded ? "25px" : "5px")};
  height: ${(props) => (props.small ? "35px" : "49px")};
  width: 100%;
  text-transform: uppercase;
  font-size: 14px;
  font-family: "MaisonNeue", sans-serif;
  text-align: center;

  /*Button Hover Animation Properties*/
  display: inline-block;
  transition: all 0.3s;
  transition: border 0s;
  position: relative;
  overflow: hidden;
  z-index: 1;

  :after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${(props) =>
      props.dark ? "#201e20" : props.light ? "#fff" : "#cff16b"};
    border-radius: ${(props) => (props.rounded ? "25px" : "5px")};
    z-index: -2;
  }

  :before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0%;
    height: 100%;
    background-color: ${(props) =>
      props.outlined
        ? "transparent"
        : props.dark || props.light
        ? "#cff16b"
        : "#FFF"};
    transition: all 0.3s;
    border-radius: ${(props) => (props.rounded ? "25px" : "5px")};
    z-index: -1;
  }

  :hover {
    background-color: transparent;
    border: ${(props) => (props.dark ? "1px solid #cff16b" : "none")};
    color: ${(props) => (props.outlined ? "#cff16b" : "#201e20")};
    border-radius: ${(props) => (props.rounded ? "25px" : "5px")};
    cursor: pointer;
  }

  :hover:before {
    width: 100%;
  }
`;
